import Vue from "vue";
import axios from "axios";
import store from "./store/index";
import { serialize } from "object-to-formdata";

const options = {
  indices: false,
  nullsAsUndefineds: false,
  booleansAsIntegers: true,
  allowEmptyArrays: false,
};

class Api {
  constructor() {
    let service = axios.create({
      // baseURL: (process.env.NODE_ENV === 'development' ? 'http://api.monloco.my/api/' : 'https://app.monloco.co/api/')
      baseURL: "https://app.monloco.co/api/",
    });
    service.interceptors.response.use(Api.handleSuccess, Api.handleError);
    this.service = service;
  }

  static handleSuccess(response) {
    return response.data;
  }

  static handleError(error) {
    switch (error.response.status) {
      case 401:
        window.location.href = "/";
        Vue.$toast.error(
          "401 - Для выполнения операции необходимо авторизоваться"
        );
        store.commit("signOut");
        break;
      case 403:
        Vue.$toast.error(
          "403 - У вас нет прав доступа для выполнения операции"
        );
        break;
      case 404:
        window.location.href = "/page-not-found";
        break;
    }
    return Promise.reject(error);
  }

  static redirectTo(document, path) {
    document.location = path;
  }

  setHeader() {
    this.service.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${store.getters.getToken}`;
  }

  get(path, payload = {}) {
    this.setHeader();
    return this.service.get(path, {
      params: payload,
    });
  }

  put(path, payload) {
    this.setHeader();
    payload["_method"] = "PUT";
    return this.service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: serialize(payload, options),
    });
  }

  patch(path, payload) {
    this.setHeader();
    payload["_method"] = "PATCH";
    return this.service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: serialize(payload, options),
    });
  }

  post(path, payload) {
    this.setHeader();
    return this.service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: serialize(payload, options),
    });
  }

  destroy(path, payload) {
    this.setHeader();
    return this.service.request({
      method: "DELETE",
      url: path,
      responseType: "json",
      data: payload,
    });
  }
}

export default new Api();
